import { useCallback, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Form } from "react-bootstrap";
import RatingStar from "../../components/common/ratingStar/ratingStar";
import NearByGrid from "../../components/common/nearByGrid";
import PostGrid from "../../components/common/postGrid";
import SearchCard from "../../components/common/searchCard";
import SubscribeGrid from "../../components/common/subscribeGrid";
import PaginationBlock from "../../components/common/pagination";
import CityNameFilter from "../../components/common/cityNameFilter";
import {
  SearchPageMain,
  FindNonprofitBlock,
  SearchCardWrap,
  FindProfitTitle,
  CharitiesWrapper,
  CharitiesOther,
  CharityTitle,
  CharityDetailText,
  BrowseStateCityWrap,
  BrowseCityListWrap,
  BrowseCityList,
  BrowseCityView,
  BrowseViewButtonGroup,
  ViewAllButton,
  FindProfitTitleText,
  PaginationWrap,
  TopTopicWrap,
  TopTopicInner,
  TopTopicTitle,
  TopTopicSubTitle,
  RatingDetailBox,
  RatingText,
  RatingBoldText,
  RatingContentText,
  RatingContentTextButton,
  HotTopicHeading,
  HotTopicTitle,
  SideDetailView,
  HotTopicGroup,
  CityListName,
  CityListNew,
  NoOpening,
  NoOpeningImage,
  NoOpeningTitle,
  SearchNoSection,
  SearchNoPara,
} from "./searchPageStyle";
import { useDispatch, useSelector } from "react-redux";
import FilterDropdown from "../../components/common/filterDropdown/filterDropdown";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { campCategoryHandler } from "../../redux/slices/donationCamp/campCategory-slice";
import { DropdownOptions, TopCityProps } from "../../utils/types";
import { MESSAGE } from '../../utils/message';
import { nonprofitsHandler } from "../../redux/slices/donationCamp/nonprofit-slice";
import { similarNonprofitHandler } from "../../redux/slices/donationCamp/similarNonprofit-slice";
import { nearByCitiesHandler } from "../../redux/slices/location/nearBy-cities";
import NearByGridCause from "../../components/common/nearByGrid/nearByGridCause";
import { citiesHandler } from "../../redux/slices/donationCamp/cities-slice";
import NoOpeningCol from '../../assests/images/category-not-found.svg';
import NearByGridFilter from "../../components/common/nearByGrid/nearByFilter";
import SimpleLoader from "../../components/common/simpleLoader/Loader";
import MetaComponent from "../../components/common/metaComponent";
import { topCitiesHandler } from "../../redux/slices/donationCamp/topCities-slice";
import NoImage from "../../assests/images/gnp_noimg.png"

const SearchPage = () => {
  const dispatch: any = useDispatch();
  const navigate: any = useNavigate();
  const location = useLocation();
  const { zipcode, stateName, cityName, categoryName, country, ...rest } = useParams();

  const restData: any = rest["*"]; // Get the string from rest
  const paramsArray = restData?.split("/"); // Split by "/"
  const categoryParam = paramsArray.find((param: any) => param.startsWith("category:")); // Find "category:"
  const category = categoryParam ? categoryParam.split(":")[1] : null; // Extract the value after "category:"




  const { stateFullName, zipcodeAdd } = location.state || {};
  const [filterFlag, setFilterFlag] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>('most-relevant');
  const nearByCities: any = useSelector((state: any) => state?.nearByCities?.data?.results);
  const campCategory: any = useSelector((state: any) => state?.campCategory?.data?.results);
  const similarNonprofit: any = useSelector((state: any) => state?.similarNonprofit?.data?.results);
  const topCitiesData = useSelector((state: TopCityProps) => state?.topCities?.data?.results);
  const nonprofitsData: any = useSelector((state: any) => state?.nonprofits?.data?.results);
  const [loader, setLoader] = useState(false);
  const search = typeof localStorage !== "undefined" && localStorage.getItem('search')
  const totalPages: any = useSelector((state: any) => state?.nonprofits?.data?.total_pages);
  const currentPage: any = useSelector((state: any) => state?.nonprofits?.data?.current_page);
  const [city, setCity] = useState<any>({ state: "", city: "", stateName: "", zipcodeData: '' });
  const localCause = typeof localStorage !== "undefined" && localStorage.getItem("cause")
  const [selectedCauseName, setSelectedCauseName] = useState<any>(localCause ?? '');

  const [type, setType] = useState('')
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPage, setTotalPage] = useState(1);
  const footerCities: any = useSelector((state: any) => state?.footerCities?.data?.results);

  const extractCategorySortDirection = () => {
    const pathname = location.pathname;

    const pattern = /\/search:([^/]+)|\/category:([^/]+)|\/sort:([^/]+)|\/direction:([^/]+)/g;

    let category = '';
    let sort = '';
    let direction = '';
    let searchData = "";

    const matches = pathname.match(pattern);

    if (matches) {
      matches.forEach(match => {
        if (match.startsWith('/category:')) {
          category = match.substring(10);
        } else if (match.startsWith('/sort:')) {
          sort = match.substring(6);
        } else if (match.startsWith('/direction:')) {
          direction = match.substring(11);
        } else if (match.startsWith('/search:')) {

          searchData = match.substring(8).replace(/%20/g, ' ');
        }
      });
      typeof localStorage !== "undefined" && localStorage.setItem('search', searchData);
      typeof localStorage !== "undefined" && localStorage.setItem('category', category);
      typeof localStorage !== "undefined" && localStorage.setItem('sort', sort);
      typeof localStorage !== "undefined" && localStorage.setItem('direction', direction);

      return { category, sort, direction };
    } else {
      return null;
    }
  };


  useEffect(() => {
    zipcodeAdd && typeof localStorage !== "undefined" && localStorage.setItem('zipcodeAdd', zipcodeAdd);
  }, [zipcodeAdd])

  useEffect(() => {

    dispatch(topCitiesHandler(stateName) as any);
  }, [stateName])

  useEffect(() => {
    setLoader(false);
  }, [nonprofitsData])
  useEffect(() => {
    if (nonprofitsData?.length === 0) {
      setTotalPage(0);
    }
  }, [nonprofitsData])

  useEffect(() => {
    setTotalPage(totalPages);
  }, [totalPages])

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage])

  useEffect(() => {
    extractCategorySortDirection();
    dispatch(citiesHandler());
  }, [])

  useEffect(() => {
    const category = typeof localStorage !== "undefined" && localStorage.getItem('category');
    const sort = typeof localStorage !== "undefined" && localStorage.getItem('sort');
    if (category) {
      setSelectedCauseName({ cause: category });
    }
    if (sort) {
      setSelectedFilter(sort);
    }
  }, [])

  useEffect(() => {

    const category = typeof localStorage !== "undefined" && localStorage.getItem('category');
    const sort = typeof localStorage !== "undefined" && localStorage.getItem('sort');
    if (category) {
      setSelectedCauseName({ cause: category });
    }
    if (location.pathname.includes('/near-me')) {
      localStorage.removeItem('search');
    }
    if (sort) {
      setSelectedFilter(sort);
    }
  }, [location.pathname])

  const buildCityURL = () => {
    typeof localStorage !== "undefined" && localStorage.removeItem('search')
    if (!city?.city || !city?.state) return null;
    typeof localStorage !== "undefined" && localStorage.setItem('stateFullName', city?.stateName);
    typeof localStorage !== "undefined" && localStorage.setItem('zipcodeAdd', city?.zipcodeData);
    if (selectedFilter && selectedFilter !== "Sort By") {
      return `/city/${city.city}/${city.state}/category:${selectedCauseName?.cause || ""}/sort:${selectedFilter}/direction:desc`;
    }

    return `/city/${city.city}/${city.state}/sort:${selectedFilter || ""}/direction:desc`;
  };

  const buildCauseURL = () => {
    if (!selectedCauseName || typeof selectedCauseName?.cause !== 'string') return null;

    const basePath = location.pathname
      .replace(/\/category:[^/]+/, '')
      .replace(/\/sort:[^/]+\/direction:[^/]+/, '');

    if (categoryName) {
      return `/categories/view/${selectedCauseName.cause}`
    }

    return `${basePath}/category:${selectedCauseName.cause}/sort:${selectedFilter || ""}/direction:desc`;
  };

  const buildFilterURL = () => {
    const basePath = location.pathname.replace(/\/sort:[^/]+\/direction:[^/]+/, '');
    return `${basePath}/sort:${selectedFilter || ""}/direction:desc`;
  };


  const handleClick = () => {
    let newURL = null;

    if (type === 'city') {
      newURL = buildCityURL();
    } else if (type === 'cause') {
      newURL = buildCauseURL();
    } else if (filterFlag) {
      newURL = buildFilterURL();
      setFilterFlag(false);
    }

    if (newURL) {
      navigate(newURL, { replace: true });
    }
  };


  useEffect(() => {
    handleClick();
  }, [selectedFilter, selectedCauseName, city]);


  const handlePageClick = (page: any) => {
    const pageNumber = page;
    setPage(pageNumber);
  };

  const handlePre = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const handleNext = () => {
    if (page < totalPage) {
      setPage(page + 1);
    }
  };

  const handleCityChange = (event: any) => {
    const selectedCityName = event.target.value;
    let selectedCityData = null;

    topCitiesData?.forEach((topCity: any) => {
      const foundCity = topCity?.cities.find((city: any) => city?.name === selectedCityName);
      if (foundCity) {
        selectedCityData = {
          state: foundCity?.state,
          city: foundCity?.slug,
          stateName: topCity?.state?.name,
          zipcodeData: foundCity?.zipcode
        };
      }
    });

    if (selectedCityData) {
      setCity(selectedCityData);
      setType('city');
    }
  };

  useEffect(() => {
    dispatch(campCategoryHandler());
    dispatch(similarNonprofitHandler());
    dispatch(nearByCitiesHandler());
  }, [])

  useEffect(() => {
    zipcode && dispatch(nearByCitiesHandler(zipcode));
  }, [zipcode])

  useEffect(() => {
    if (typeof localStorage !== "undefined" && localStorage.getItem('zipcodeAdd') != null) {
      dispatch(nearByCitiesHandler(typeof localStorage !== "undefined" && localStorage.getItem('zipcodeAdd')));
    }
  }, [typeof localStorage !== "undefined" && localStorage.getItem('zipcodeAdd')])
  const searchDataApi = () => {
    const storedValue: any = typeof localStorage !== "undefined" && localStorage?.getItem('search');
    const _zipcode = storedValue?.match(/zipcode:(\d+)/)?.[1];
    dispatch(nonprofitsHandler({
      all: false,
      search: (stateName === undefined && cityName === undefined && typeof localStorage !== "undefined" && localStorage.getItem('search'))
        ? localStorage?.getItem('search')?.split("&")?.[0]
        : '',
      // search: stateName == undefined && cityName == undefined && (typeof localStorage !== "undefined" && localStorage.getItem('search')) ?
      //   localStorage?.getItem('search')?.split("&")?.[0] : '',
      // zipcode: (typeof localStorage !== "undefined" && zipcode) ?
      //   zipcode || '' : "",
      zipcode: zipcode ?
        zipcode : _zipcode ? _zipcode : "",
      ...(typeof localStorage !== "undefined" && !localStorage.getItem('search') && !zipcode && {
        country: country ?? 'USA',
        state: stateName ?? 'CA',
        city: cityName ?? 'san-francisco',

      }),
      //country: country ?? 'USA', state: stateName ?? 'CA', city: cityName ?? 'san-francisco',
      category: selectedCauseName?.cause || categoryName || typeof localStorage !== "undefined" && localStorage.getItem('category'),
      sort_by: (selectedFilter || typeof localStorage !== "undefined" && localStorage.getItem('sort')) !== "Sort By" ? selectedFilter : "", page, size: limit
    }))
    setLoader(true);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page])
  useEffect(() => {

    searchDataApi();
  }, [selectedFilter, selectedCauseName?.cause, cityName, page, zipcode, search])

  const options: DropdownOptions[] = [
    { label: "Most Relevant", value: "most-relevant" },
    { label: "Most Recently Reviewed", value: "most-recently-reviewed" },
    { label: "Most Reviewed", value: "most-reviewed" },
    { label: "Highest Rating", value: "highest-rating" },
    { label: "Name", value: "name" },
  ]
  const formatTitle = () => {
    const formatName = (name: string) =>
      name.split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    if (cityName && stateName) {
      return MESSAGE.searchNonprofitsCity(formatName(cityName));
    }

    if (stateName) {
      return MESSAGE.searchNonprofitsCityState(formatName(stateName));
    }

    if (zipcode) {
      return `Nonprofits within 10 sq. miles of ${zipcode}`;
    }

    return MESSAGE.searchNonprofits('Find');
  };


  const metaTitle = useCallback(() => {


    if (location.pathname.includes('/near-me')) {
      return "Find Nonprofits Near Me | GreatNonprofits";
    }

    if (categoryName) {
      return `${categoryName
        .split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')} Nonprofits and Charities | GreatNonprofits`;
    }

    if (categoryName || extractCategorySortDirection()?.category)
      return `Find ${extractCategorySortDirection()?.category?.charAt(0).toUpperCase() as any + extractCategorySortDirection()?.category?.slice(1).toLowerCase() as any} Nonprofits and Charities Near ${cityName}`

    if (cityName && extractCategorySortDirection()?.sort && !extractCategorySortDirection()?.category) {
      return `${cityName.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')} Nonprofits and Charities`;
    }

    // if (cityName && extractCategorySortDirection()?.sort && !extractCategorySortDirection()?.category) {
    //   return `${cityName.split('-')
    //     .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    //     .join(' ')} Nonprofits and Charities`;
    // }

    // if (extractCategorySortDirection()?.category && cityName && extractCategorySortDirection()?.sort)
    //   return `Find ${extractCategorySortDirection()?.category?.charAt(0).toUpperCase() as any + extractCategorySortDirection()?.category?.slice(1).toLowerCase() as any} Nonprofits and Charities Near ${cityName}`

    if (cityName && stateName && !selectedCauseName?.cause) {
      if (typeof localStorage !== "undefined" && localStorage.getItem('stateFullName'))
        return `Nonprofits and Charities in ${cityName.split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}, ${typeof localStorage !== "undefined" && localStorage.getItem('stateFullName')}| GreatNonprofits`;
      else if (stateFullName)
        return `Nonprofits and Charities in ${cityName.split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}, ${stateFullName} | GreatNonprofits`;
      else {
        return `Nonprofits and Charities in ${cityName.split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}, ${stateName} | GreatNonprofits`;
      }
    }


    if (stateName) {
      return `Top-Rated Nonprofits in ${stateName} | GreatNonprofits`;
    }

    if (zipcode) {
      return `Nonprofits and Charities within 10 sq. miles of ${zipcode} - Volunteer, Donate, Review`;
    }





    return "Charity and non profit reviews and ratings on Greatnonprofits.org by volunteers, donors, clients on GreatNonprofits";
  }, [selectedCauseName, cityName, stateName, categoryName, zipcode, stateFullName, extractCategorySortDirection()]);



  const metaDescription = useCallback(() => {


    if (location.pathname.includes('/near-me')) {
      return "Find top-rated nonprofits near you on GreatNonprofits. Read reviews, explore causes, and connect with organizations to support or volunteer with today!";
    }

    if (categoryName) {
      return `Find ratings and read reviews of ${categoryName.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')} nonprofit organizations on GreatNonprofits. Browse for top ${categoryName.split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))

          .join(' ')} charities and nonprofits to donate to and volunteer for today!`
    }

    const categorySortDirection = extractCategorySortDirection();
    if (cityName && categorySortDirection?.sort && !categorySortDirection?.category) {
      return `Explore top nonprofits and charities in ${cityName?.charAt(0).toUpperCase() as any + cityName?.slice(1).toLowerCase() as any}. Read reviews, find impactful causes, and connect to support or volunteer with local organizations!`
    }

    if (categoryName || extractCategorySortDirection()?.category)
      return `Find top ${extractCategorySortDirection()?.category?.charAt(0).toUpperCase() as any + extractCategorySortDirection()?.category?.slice(1).toLowerCase() as any} nonprofits and charities near ${cityName?.charAt(0).toUpperCase() as any + cityName?.slice(1).toLowerCase() as any}. Read reviews, learn about their impact, and connect to support or volunteer today!`

    // if (cityName && stateName && categoryParam) {
    //   return `Explore top nonprofits and charities in ${cityName}.Read reviews, find impactful causes, and connect to support or volunteer with local organizations!`
    // }
    if (cityName && stateName && !selectedCauseName?.cause) {
      return `Find top-rated nonprofits in ${cityName
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")}, ${stateName} on GreatNonprofits. Find top organizations that are making a difference and are highly rated by the community.`;
    }

    if (stateName) {
      return `Want to donate or volunteer? Explore the top-rated nonprofits in  ${stateName} on GreatNonprofits. Find opportunities to support or collaborate with these organizations.`;
    }

    if (zipcode) {
      return `Find and review within 10 sq. miles of 11212 charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best non-profit or charity within 10 sq. miles of ${zipcode}`;
    }

    if (selectedCauseName?.cause)
      return `Find ratings and read reviews of ${selectedCauseName.cause.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')} nonprofit organizations on GreatNonprofits. Browse for top ${selectedCauseName.cause.split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')} charities and nonprofits to donate to and volunteer for today!`


    return "Charity and non profit reviews and ratings on Greatnonprofits.org by volunteers, donors, clients on GreatNonprofits";
  }, [cityName, stateName, categoryParam, zipcode, selectedCauseName, categoryName, extractCategorySortDirection()]);

  const handleKeywords = () => {
    let keywords;
    if (city?.city && selectedCauseName?.cause && zipcode)
      keywords = city?.city + "," + city?.state + "," + selectedCauseName?.cause + "," + zipcode + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (city?.city && selectedCauseName?.cause)
      keywords = city?.city.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + "," + city?.state + "," + selectedCauseName?.cause + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (city?.city && zipcode)
      keywords = city?.city.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + "," + city?.state + "," + zipcode + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (zipcode)
      keywords = zipcode + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (selectedCauseName?.cause)
      keywords = selectedCauseName?.cause.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (categoryName)
      keywords = categoryName.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (cityName && stateName)
      keywords = cityName.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + "," + stateName + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else if (stateName)

      return stateName + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    else
      keywords = city?.city.split('-')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') + "," + city?.state + `,nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits`;
    return keywords;
  }


  const handleogUrl = useCallback(() => {

    if (location.pathname.includes('/near-me')) {
      return "https://new.greatnonprofits.org/near-me/";
    }
    // if (cityName && extractCategorySortDirection()?.sort && !extractCategorySortDirection()?.category) {
    //   return `${cityName.split('-')
    //     .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    //     .join(' ')} Nonprofits and Charities`;
    // }

    // if (extractCategorySortDirection()?.category && cityName && extractCategorySortDirection()?.sort)
    //   return `Find ${extractCategorySortDirection()?.category?.charAt(0).toUpperCase() as any + extractCategorySortDirection()?.category?.slice(1).toLowerCase() as any} Nonprofits and Charities Near ${cityName}`

    if (cityName && stateName && !selectedCauseName?.cause) {
      if (typeof localStorage !== "undefined" && localStorage.getItem('stateFullName'))
        return `https://new.greatnonprofits.org/city/${cityName}/${stateName}`;
      else if (stateFullName)
        return `https://new.greatnonprofits.org/city/${cityName}/${stateName}`;
      else {
        return `https://new.greatnonprofits.org/city/${cityName}/${stateName}`;
      }
    }


    if (stateName) {
      return `https://new.greatnonprofits.org/state/${stateName}`
    }



    if (categoryName) {
      return `https://new.greatnonprofits.org/categories/view/${categoryName}`;
    }

    return "https://new.greatnonprofits.org/";
  }, [selectedCauseName, cityName, stateName, categoryName, zipcode, stateFullName, extractCategorySortDirection()]);

  const handleCanonicalUrl = useCallback(() => {
    if (location.pathname.includes('/near-me')) {
      return "https://new.greatnonprofits.org/near-me/";
    }
    if (cityName && stateName) {
      return `https://new.greatnonprofits.org/city/${cityName}/${stateName}`;
    }

    if (stateName) {
      return `https://new.greatnonprofits.org/state/${stateName}`

    }



  }, [stateName, cityName])

  return (
    <>
      <MetaComponent
        key={`${cityName}-${stateName}-${categoryName}-${zipcode}-${selectedCauseName?.cause}`}
        keywords={handleKeywords()}
        description={metaDescription()}
        ogTitle={metaTitle()}
        ogDescription={metaDescription()}
        ogUrl={handleogUrl()}
        ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
        twitterTitle={metaTitle()}
        twitterDescription={metaDescription()}
        twitterUrl={handleogUrl()}
        twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
        canonicalUrl={handleCanonicalUrl()}

      />
      <SearchPageMain>

        <Container className="header-container">
          <Row>

            <Col sm="12" md="3" lg="2">

              <CityListName>
                {location.pathname.startsWith('/state/') ?
                  <Form.Select aria-label="Default select example" onChange={handleCityChange}>
                    <option>Select City</option>
                    {topCitiesData?.map((topCity: any) => topCity?.cities.map((city: any, index: number) => (<option key={index + 1} value={city?.name}
                    >{city?.name}</option>)))}
                  </Form.Select> :
                  <NearByGrid
                    listData={nearByCities}
                    title="Nearby Cities"
                    selectedItem={cityName}
                    setSelectedItem={setCity}
                    handleChange={(name: string) => setType(name)}
                  />}
                {(cityName !== undefined || stateName !== undefined) &&
                  <NearByGridFilter
                    options={options}
                    selectedFilter={selectedFilter}
                    setSelectedFilter={setSelectedFilter}
                    setFilterFlag={setFilterFlag}
                  />
                }
                <NearByGridCause
                  listData={campCategory}
                  title="All issues"
                  selectedItem={selectedCauseName}
                  setSelectedItem={setSelectedCauseName}
                  handleChange={(name: string) => setType(name)}
                />
              </CityListName>
            </Col>

            <FindNonprofitBlock className="search-no-col" as={Col} md="9" lg="7">
              <FindProfitTitle>
                <FindProfitTitle>
                  <FindProfitTitleText>{formatTitle()}</FindProfitTitleText>
                </FindProfitTitle>
                {(cityName === undefined && stateName === undefined) &&
                  <FilterDropdown
                    options={options}
                    selectedFilter={selectedFilter}
                    setSelectedFilter={setSelectedFilter}
                    setFilterFlag={setFilterFlag}
                  />}
              </FindProfitTitle>

              {loader ? <div className="loader"><SimpleLoader /></div> : <>
                {nonprofitsData?.length > 0 ?
                  <SearchCardWrap>
                    <SearchCard searchNonprofit={nonprofitsData} />
                  </SearchCardWrap>
                  : <NoOpening>
                    <NoOpeningImage><Image src={NoOpeningCol} /></NoOpeningImage>
                    <NoOpeningTitle>{MESSAGE.noSearch((typeof localStorage !== "undefined" && localStorage.getItem('search') ? localStorage.getItem('search') : "") + " " + (zipcode ?? "") + " " + (cityName ?? "") + " " + (stateName ?? "") + " " + (categoryName ?? ""))}</NoOpeningTitle>

                    <SearchNoSection className="searchnoopening">
                      <SearchNoPara><strong>Suggestions for improving your search results:</strong></SearchNoPara>
                      <SearchNoPara>Try to broaden your search</SearchNoPara>
                      <SearchNoPara>Check the spelling</SearchNoPara>
                      <SearchNoPara>Try alternate spellings</SearchNoPara>
                    </SearchNoSection>
                  </NoOpening>}
              </>}

              {!loader && <PaginationWrap>
                {totalPage > 1 && <PaginationBlock totalPage={totalPage} page={page} handlePre={handlePre} handleNext={handleNext} handlePageClick={handlePageClick} />}
              </PaginationWrap>}
            </FindNonprofitBlock>

            <Col md="12" lg="3">
              <SideDetailView className="search-page">
                <SubscribeGrid />

                <TopTopicWrap className="top-topic-wrap" key={similarNonprofit?.review_id}>

                  <Image className="hot-topic-img" src={similarNonprofit?.image || NoImage} alt="Palomacy Pigeon" />

                  <TopTopicInner>
                    <TopTopicTitle>{similarNonprofit?.address}</TopTopicTitle>
                    <TopTopicSubTitle>
                      {similarNonprofit?.org_title}
                    </TopTopicSubTitle>
                    <RatingDetailBox>
                      <RatingStar review={0} rating={similarNonprofit?.review_rating} />

                      <RatingText>
                        Reviewed by
                        <RatingBoldText>{similarNonprofit?.username}</RatingBoldText>
                      </RatingText>

                      <RatingContentText>
                        {similarNonprofit?.review_text}
                        {similarNonprofit?.review_text?.length > 155 &&
                          <RatingContentTextButton onClick={() => navigate(`/org/${similarNonprofit?.org_slug}`)}> Read More</RatingContentTextButton>
                        }

                      </RatingContentText>
                    </RatingDetailBox>
                  </TopTopicInner>

                </TopTopicWrap>

                <HotTopicGroup className="hot-topic-group-main">
                  <HotTopicHeading>
                    <HotTopicTitle>{MESSAGE.hotTopicLabel}</HotTopicTitle>
                  </HotTopicHeading>
                  <PostGrid />
                </HotTopicGroup>
              </SideDetailView>

            </Col>
          </Row>


          <CharitiesWrapper>
            <CharitiesOther>
              <CharityTitle>{MESSAGE.NonprofitsCharitiesTitle}</CharityTitle>

              <CharityDetailText>
                Whether your causes are animal shelters, food banks, or breast cancer groups, you'll find real nonprofit reviews you can trust at GreatNonprofits.
              </CharityDetailText>

              <CharityDetailText>
                Millions of nonprofit clients, donors, and volunteers have shared their candid reviews of charities, nonprofits, and social enterprises.
              </CharityDetailText>

              <CharityDetailText>
                Add your nonprofit reviews and help other donors and volunteers find a great nonprofit.
              </CharityDetailText>
            </CharitiesOther>
          </CharitiesWrapper>

          <BrowseStateCityWrap>
            <CityNameFilter />
            <BrowseCityListWrap>
              <BrowseCityList>
                <CityListNew className="abc">
                  {footerCities?.map((city: any, index: number) => (<BrowseCityView key={index + 1} onClick={() => {
                    typeof localStorage !== "undefined" && localStorage.setItem('search', "");
                    navigate(`/city/${city?.slug}/${city?.state}`, { state: { resetSearch: true } })

                  }
                  }>{city?.city} Charities</BrowseCityView>))}
                  <BrowseViewButtonGroup>
                    <ViewAllButton onClick={() => window.location.href = `/navigation/state`}>
                      {MESSAGE.viewAllCities}
                    </ViewAllButton>
                    <ViewAllButton onClick={() => window.location.href = `/navigation/state`}>
                      {MESSAGE.viewByState}
                    </ViewAllButton>
                    <ViewAllButton onClick={() => window.location.href = `/navigation/state`}>
                      {MESSAGE.browseByStateAndCity}
                    </ViewAllButton>
                  </BrowseViewButtonGroup>
                </CityListNew>


              </BrowseCityList>
            </BrowseCityListWrap>
          </BrowseStateCityWrap>
        </Container>
      </SearchPageMain>
    </>
  );
};
export default SearchPage;
